<template>
    <div class="card">
        <div class="card-body">
            <h4 class="card-title">{{ cardTitle }}</h4>

            <p class="card-title-desc">
                {{ description }}
            </p>

            <div class="col-8 d-flex align-items-center mb-2">
                <b-form-input v-model="searchFilter" type="search" placeholder="Αναζητήστε Όνομα ή Κάρτας"
                    @keyup.enter="onSearchPerson"></b-form-input>
                <b-input-group-append class="d-flex">
                    <b-button variant="primary" @click.prevent="onSearchPerson">
                        <i class="bx bx-search-alt-2"></i>
                    </b-button>
                    <b-button v-if="searchFilter.length > 0" variant="danger" @click.prevent="clearSearch">
                        <i class="bx bx-x"></i>
                    </b-button>

                </b-input-group-append>
            </div>
            <div class="col-8 d-flex align-items-center">
                <multiselect v-model="departmentValue" :options="departmentNames" track-by="id" label="name"
                    placeholder="Επιλέξτε Τμήμα" selectLabel="Eπιλογή Τμήματος" selectedLabel="Επιλέχθηκε"
                    deselectLabel="Αποεπιλογή" @input="emptyPeopleField" :max-height="200"></multiselect>
            </div>
            <div class="justify-content-between col-12">
                <b-table :items=entity :fields="tableFields">
                    <template #cell(is_in_entity)="row">
                        <b-form-checkbox @change="chItem($event, row.item)" :checked="checkingCheckbox(row.item)"
                            plain></b-form-checkbox>
                    </template>
                </b-table>
                <b-pagination v-model="currentPageModal" :total-rows="count" :per-page="perPage"
                    aria-controls="my-table" class="pagination pagination-rounded mb-0"></b-pagination>
                <b-button class="btn mt-2" variant="primary" @click="submitSelection">Υποβολή</b-button>
            </div>

            <b-modal id="edit-modal-center" size="sm" title="Παρακαλώ περιμένετε..." title-class="font-18" hide-footer>
                <div class="text-center">
                    <b-spinner v-show="spinnerShow" class="m-2" variant="primary" role="status">
                    </b-spinner>
                    <p>Γίνεται επεξεργασία των στοιχείων..</p>
                </div>
            </b-modal>

        </div>
    </div>
</template>

<script>
import session from "../../../../api/session";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";
// import Swal from "sweetalert2";
export default {
    props: {
        modalId: String,
        cardTitle: String,
        description: String,
        supervisorId: {
            required: false,
            type: Number,
        },
    },
    components: {
        Multiselect,
    },
    data() {
        return {
            entity: [],
            tableFields: [
                { key: 'is_in_entity', label: 'Επιλογή' },
                { key: 'person_full_name', label: 'Ονοματεπώνυμο' },
                { key: 'person_card_number', label: 'Αριθμός Κάρτας' },
            ],
            currentPageModal: 1,
            perPage: 10,
            count: 0,

            selectedPeople: {},
            searchFilter: "",
            searchDepartmentFilter: "",
            spinnerShow: false,
            selected: {},
            itemsSelected: [],
            departmentValue: ""
        }
    },
    // created() {
    //     this.preFillDepartmentValue();
    // },
    computed: {
        ...mapState("utils", ["departmentOptions",]),
        departmentNames() {
            return this.departmentOptions.map((e) => {
                return { id: e.id, name: e.department_parent_name };
            });
        },
        selectedPeopleIds() {
            return Object.keys(this.selectedPeople)
                .filter(id => this.selectedPeople[id] && !isNaN(id))
                .map(Number);
        },
    },
    watch: {
        currentPageModal() {
            this.fetchPeople();
        },
    },
    methods: {
        // preFillDepartmentValue() {
        //     if (!(this.is_staff || this.is_superuser)) {
        //         this.departmentValue = this.departmentOptions.map(
        //             (e) => `${e.parent_name}/${e.name}`
        //         )[0];
        //     }
        // },
        emptyPeopleField() {
            this.currentPageModal = 1;
            this.fetchPeople();
        },
        checkingCheckbox(row) {
            const rowExists = this.itemsSelected.find(e => e.id == row.id)
            return rowExists != undefined ? rowExists.is_in_entity : row.is_in_entity
        },
        chItem(e, row) {
            const selectedRow = { ...row, is_in_entity: e }
            const index = this.itemsSelected.findIndex(item => item.id === row.id);
            if (index !== -1) {
                this.$set(this.itemsSelected, index, selectedRow);
            } else {
                this.itemsSelected.push(selectedRow);
            }

            this.$set(this.selected, row.id, e)
            console.log(this.selected);
            console.log(this.itemsSelected);
        },
        async fetchPeople() {
            let data = {
                page: this.currentPageModal,
                search: this.searchFilter
            }
            if (this.departmentValue) {
                data.department = this.departmentValue.id || "";
            }
            let urlparams = new URLSearchParams(data).toString();
            await session
                .get(`api/people-list/${this.supervisorId}/?${urlparams}`)
                .then((resp) => {
                    console.log(resp.data.results);
                    this.entity = resp.data.results;
                    this.count = resp.data.count;
                }).catch((e) => {
                    console.log(e.response.data);
                })

        },
        async submitSelection() {
            this.spinnerShow = true;
            this.$bvModal.show("edit-modal-center");
            console.log(this.selected);
            if (Object.keys(this.selected).length > 0) {
                const addToMembers = Object.keys(this.selected).filter(key => this.selected[key] === true).map(Number);
                const removeFromMembers = Object.keys(this.selected).filter(key => this.selected[key] === false).map(Number);
                console.log(addToMembers, removeFromMembers);
                const data = {
                    supervisor: this.supervisorId,
                    membersToAdd: [...addToMembers],
                    membersToRemove: [...removeFromMembers]
                }
                await session
                    .patch(`api/entity-group/update/${this.supervisorId}/`, data)
                    .then(() => {
                        this.spinnerShow = false;
                        this.$bvModal.hide("edit-modal-center");
                        this.$emit("fetchEntity");
                    })

            }
            this.spinnerShow = false;
            this.$bvModal.hide("edit-modal-center");
            this.closeModal();


        },
        closeModal() {
            this.selected = {};
            this.$bvModal.hide('editGroupModal');
        },
        onSearchPerson() {
            this.currentPageModal = 1;
            this.fetchPeople();
        },
        clearSearch() {
            this.searchFilter = "";
            this.currentPageModal = 1;
            this.fetchPeople();
        },
    },
    mounted() {
        this.fetchPeople();
    }
};
</script>
